import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const ClientCategoriesPage = lazy(() => import('@pages/clientCategories/ClientCategoriesPage'));

// Route Component
const ClientCategoryTablePage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('client-categories-page-title')}>
        <ClientCategoriesPage />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default {
  ClientCategoryTablePage,
};
